import axios from "axios";

// same address as the page unless REACT_APP_BACKEND_URL says otherwise (e.g. local development)
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// The access cookie lives 15 minutes; the refresh cookie 7 days. On a 401, renew the access
// cookie once via /auth/refresh and retry the request — otherwise every save after 15 minutes
// (including silent autosaves) is rejected and the user is sent back to sign in. Concurrent 401s
// share one refresh call.
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    const isAuthCall = /\/auth\/(login|refresh|logout)$/.test(url);
    if (error.response?.status !== 401 || !original || original._retried || isAuthCall) {
      return Promise.reject(error);
    }
    original._retried = true;
    refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
    try {
      await refreshing;
    } catch {
      return Promise.reject(error); // refresh token expired too — caller sees the original 401
    }
    return api(original);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && detail.validation_errors) return detail.validation_errors.join(" ");
  return JSON.stringify(detail);
}

export { API };
export default api;
